/* eslint-disable @typescript-eslint/no-explicit-any */
import { store } from "@/store/store";
import {
  setSocketConnected,
  addMessage,
  incrementUnread,
  setTypingEditor,
  markMessageSeen,
  replaceMessage,
  setChannelId,
  setMessages,
  resetCsrChat,
} from "@/store/csr-chat/csr-chat-slice";
import { ChatEvent, updateSocketHandlers } from "./socket-service";
import type { IUserInfo } from "@/hooks/use-user-info";
import ScreenRouteNames from "@/constants/screen-route-names";
import { notifyNewMessage, clearTitleNotification } from "./title-notification";
import { showChatNotification } from "@/notifications/show";
import {
  CSR_MESSAGE_TYPE,
  CSR_ROLE_BOT,
} from "@/services/csr-chat/csr-chat-constants";

export const initChatSocketBridge = (userInfo: IUserInfo): void => {
  updateSocketHandlers({
    onConnect: () => store.dispatch(setSocketConnected(true)),
    onDisconnect: () => store.dispatch(setSocketConnected(false)),

    onNewMessage: (data: any) => {
      const msg = data?.data?.message;
      if (!msg) return;
      store.dispatch(addMessage(msg));
      if (
        msg?.role?.toLocaleString() === CSR_ROLE_BOT &&
        msg?.type?.toLocaleString() === CSR_MESSAGE_TYPE?.INFO
      )
        return;
      if (!window.location.pathname.includes(ScreenRouteNames.CSR_CHAT.path)) {
        store.dispatch(incrementUnread());
      }
      notifyNewMessage();
      showChatNotification();
    },

    onUserTypingStatus: (data: any) => {
      const { chatChannel } = data?.data ?? {};
      if (!chatChannel) return;
      const editor =
        data?.data?.editor?.filter(
          (e: any) => e?.username !== userInfo?.username,
        )?.[0] ?? null;
      store.dispatch(setTypingEditor({ channelId: chatChannel, editor }));
    },

    onMessageStatusChange: (data: any) => {
      const msg = data?.data;
      if (!msg?._id || !msg?.chatChannel) return;
      store.dispatch(
        markMessageSeen({
          chatChannel: msg.chatChannel,
          messageId: msg._id,
          receiver: msg.receiver ?? [],
        }),
      );
    },

    onEcho: (data: any) => {
      const responseData = data?.data;
      if (
        data?.type === ChatEvent.NEW_MESSAGE &&
        responseData?.message &&
        responseData?.tempId
      ) {
        const { message, tempId } = responseData;
        store.dispatch(
          replaceMessage({
            chatChannel: message.chatChannel,
            tempId,
            realMessage: message,
          }),
        );
      } else if (
        data?.type === ChatEvent.NEW_CHANNEL &&
        responseData?.channel?._id
      ) {
        store.dispatch(setChannelId(responseData.channel._id));
        if (responseData.message) {
          store.dispatch(
            setMessages({
              channelId: responseData.channel._id,
              msgs: [responseData.message],
            }),
          );
        }
      }
    },
  });
};

export const teardownChatSocketBridge = (): void => {
  updateSocketHandlers({});
  store.dispatch(resetCsrChat());
  clearTitleNotification();
};
